import type {Profile as ProfileType, ProfileSubscriptionInfo, SocialAccount} from './../types'
import AuthorModel from "~/repository/models/Author";
import SocialAccountModel from "~/repository/models/SocialAccount"

export default class Profile extends AuthorModel implements ProfileType {
    social_accounts: Array<SocialAccount>
    is_owner?: boolean
    is_creator: boolean
    subscription: ProfileSubscriptionInfo

    constructor(data: ProfileType) {
        super(data)
        this.social_accounts = data.social_accounts.map(SocialAccountModel.create)
        this.is_owner = data.is_owner
        this.is_creator = data.is_creator
        this.subscription = data.subscription
    }

    public static async get(username: string) {
        return (await $api.user.get(username)).data
    }
}
